export const IconCopy: {
  name: 'icon_copy-683cb3123df6'
} = {
  name: 'icon_copy-683cb3123df6'
}
